import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shimen"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1.99902 4.00098L11.999 3.00098L21.999 4.00098V7.00098C18.6657 7.33431 15.3324 7.66764 11.999 8.00098L1.99902 7.00098V4.00098Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M3.99902 21.0008L4.99902 7.30078L7.99902 7.60078L8.99902 21.0008H3.99902Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M19.999 21.0008L18.999 7.30078C17.9605 7.40464 17.1041 7.50075 16.1038 7.60078L14.999 21.0008H19.999Z"}}]},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M3.99902 21.0008L4.99902 7.30078L7.99902 7.60078L8.99902 21.0008H3.99902Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M19.999 21.0008L18.999 7.30078C17.9605 7.40464 17.1041 7.50075 16.1038 7.60078L14.999 21.0008H19.999Z","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M1.99902 4.00098L11.999 3.00098L21.999 4.00098V7.00098C18.6657 7.33431 15.3324 7.66764 11.999 8.00098L1.99902 7.00098V4.00098Z","strokeWidth":"props.strokeWidth"}}]}]};

const Shimen = Vue.extend<IconProps>({
  name: 'ShimenIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'shimen',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Shimen;
